import { render } from "./PanelDownload.vue?vue&type=template&id=0e2afc50&scoped=true&ts=true"
import script from "./PanelDownload.vue?vue&type=script&lang=ts"
export * from "./PanelDownload.vue?vue&type=script&lang=ts"

import "./PanelDownload.vue?vue&type=style&index=0&id=0e2afc50&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e2afc50"]])

export default __exports__